<template>
<div style='margin-bottom:25px'>
  <el-card :body-style="{ padding: '0px' }">
    <router-link :to="`/detail/${item.mainGuid}`">
      <img :src="item.pushPictureUrl" class="cover" />
      <p :title="item.shareName" class="absolute-p">
        {{item.shareName}}
      </p>
      <div style="display: inline-flex;" class="info-box">
        <div style="margin-right: 13px;">
          <el-avatar :size="30" :src="item.avatar"></el-avatar>
        </div>
        <span :title="item.nickName" class="nickname">{{item.nickName}}</span>
      </div>
    </router-link>
  </el-card>
  </div>
</template>

<script>
    export default {
        props: ["item"]
    }
</script>

<style type="text/less" lang="less" scoped>
  @import "../../assets/style/color";
  @import "../../assets/style/config";
  @import "../../assets/style/mixin";

  a {
    color: @color-text-regular
  }

  .cover {
    object-fit: cover;
    width: 210px;
    height: 210px;
  }

  .info-box {
    padding: 15px;
    display: flex;
    align-items: center;
    width: 100%;
    background-color: #e9e9e9;
  }

  .absolute-p {
    @height: 35px;
    padding: 0 10px;
    line-height: @height;
    margin-top: 15px;
    text-align: center;
    width: 210px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .nickname{
    width: 130px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  img {
    vertical-align: middle;
  }
</style>
